import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Panel } from 'primereact/panel';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import {DataTable} from 'primereact/datatable';
import {MultiSelect} from 'primereact/multiselect';
import {Column} from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG, CALENDAR_CONFIG, REPORTS_ID} from '../../shared/Config';
import { HASACCESS } from '../../shared/utility';
import {Calendar} from 'primereact/calendar';
import axios from '../../axios-url';
import {Link} from 'react-router-dom';
import Messages from '../../shared/UI/Messages/Messages';
import {Button} from 'primereact/button';
import { Toast } from 'primereact/toast';
import moment from 'moment';

class ReportsList extends Component {
    state = {
        selectedValue:[]
    }

    componentDidMount(){        
        this.props.getMasterTableList('Employee/GetReportList');    
        this.getAccess = HASACCESS(REPORTS_ID);
        
    }

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
            <Link to={"/report/edit/"+rowData.REPORT_SETINGS_ID}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
            <Link to={"/report/view/"+rowData.REPORT_SETINGS_ID}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
            </div>;
            }


    render() {

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }

        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let tableData = [];
        if(this.props.tableLists !== undefined){
            tableData = this.props.tableLists.Table || [];
        }
        





        return(
            <div className="p-grid padding">
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Reports</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                
                                 <Link to="/report/add/new"><Button style={{float: 'right'}} label="Add Report" className="ml1"  icon="pi pi-plus"  /></Link>
                               
                                
                                 {/* <Button  style={{float: 'right'}} onClick={this.delete} label="Delete" icon="pi pi-trash"  className="p-button-danger"/> */}
                               
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                     
                       
                        <DataTable
                        value={tableData}
                         globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG}>
                                <Column field="REPORT_NAME" header="Report Name" sortable={true} />
                                <Column field="PROCESS_DESCRIPTION" header="Process" sortable={true} body={this.renderPosNo}/>
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }









}



const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(ReportsList);